<template>
  <div class="api-page">
    <TopHeader class="api-page__header" />
    <Banner @consult-click="showContact" />
    <CoreTechs />
    <CoreFeatures @consult-click="showContact" />
    <Scenarios @consult-click="showContact" />
    <Faq @consult-click="showContact" />
    <StartRightNow
      title="商务咨询"
      :desc="'API需求、资源包定制&大量采购，请点击下方按钮扫码联系我们，\n我们将尽快与您联系，并竭诚为您服务。'"
      primary-btn-text="联系我们"
      secondary-btn-text=""
      :handler="showContact"
    />
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import { PositionCode, useContactUs } from '@rendora/common/features/contact';
import AppFooter from '~/design/widgets/bottom-footer/footer-cn.vue';
import StartRightNow from '~/design/widgets/start-right-now/index.vue';
import TopHeader from '~/design/widgets/top-header/index.vue';
import Banner from './modules/banner/index.vue';
import CoreFeatures from './modules/core-features/index.vue';
import CoreTechs from './modules/core-techs/index.vue';
import Faq from './modules/faq/index.vue';
import Scenarios from './modules/scenarios/index.vue';

import { useThrottleFn } from '@vueuse/core';

const showContact = useThrottleFn(() => {
  useContactUs(1410390 as PositionCode, 'API 需求咨询', '扫码添加产品专家·快速响应');
}, 1000);
</script>

<style lang="scss" scoped>
.api-page {
  padding-top: 64px;
  .api-page__header {
    background-color: var(--x-back-1);
  }
}
</style>
